import { useFeature } from '@growthbook/growthbook-react';
import { UserRole } from '@openx/types/user.ts';
import { usePermissionContext } from '@openx/utils/permission/context/PermissionContext.tsx';
import { DEAL_REVENUE_CALCULATOR_FEATURE_FLAG } from '../constants.ts';

export const useHasDealRevenueCalculatorAccess = () => {
  const dealRevenueCalculatorFeature = useFeature<boolean>(DEAL_REVENUE_CALCULATOR_FEATURE_FLAG);
  const { useSession } = usePermissionContext();
  const { session } = useSession();

  const hasPermissions = !!session?.real_user?.roles.includes(UserRole.DEAL_REVENUE_CALCULATOR);
  const isFeatureEnabled = !!dealRevenueCalculatorFeature.value;
  const isWorkingAsSelf = !!session?.real_user?.work_as_self;

  return hasPermissions && isFeatureEnabled && isWorkingAsSelf;
};
